
jQuery(document).ready( function($){

	if( $('.contact-submissions.list').length ) {

		var view = $('[data-for="view-message"]');
		var acknowledgeCheckboxes = $('.acknowledged');

		view.click( function(e){
			e.preventDefault();
			var url = $(this).attr('href');
			$(this).parents('tr:eq(0)').removeClass('unread').addClass('read');
			$.get( url, function( response ){
				// modal = $(response).modal().modal('show');
                $('#view-contact-submissions .modal-body').html(response);
                $('#view-contact-submissions').modal('show')
			});
		});

		acknowledgeCheckboxes.mouseup(function(){
			var acknowledgeURL = $(this).next().val();
			var row = $(this).parents('tr:eq(0)');
			$.get( acknowledgeURL, { active : ! $(this).is( ':checked' ) }, function( $submission ){
				row.toggleClass( 'danger success' );
			});
		});

	}

});
